import { Box, Typography } from '@mui/material';
import * as React from 'react';

import BlogCard from 'components/BlogCard';
import Fluid from 'components/Fluid';
import SimpleCard from 'components/SimpleCard';

const CuratedList = ({cards, title, listType, flush, background, backgroundImage, backgroundProps, padding, gridSize, ...props}) => {
	const sectionInlineStyle = {
		...(backgroundImage ? {
			backgroundImage: `url(${process.env.CDN_DOMAIN||''}${backgroundImage}?max-w=1920&format=webp)`,
			...(backgroundProps ? {
				...(backgroundProps.indexOf('cover') !== -1 ? {
					backgroundSize: 'cover',
				} : null),
				...(backgroundProps.indexOf('fixed') !== -1 ? {
					backgroundAttachment: 'fixed',
				} : null),
				...(backgroundProps.indexOf('repeat') !== -1 ? {
					backgroundRepeat: 'repeat',
				} : {backgroundRepeat: 'no-repeat'}),
			} : null),
		} : null),
	}

	if (!cards || cards?.length === 0) return null;

	return (
		<Box sx={(Object.keys(sectionInlineStyle).length > 0 ? sectionInlineStyle : null)}
			className={[
				'curatedList__section', 
				(padding ? 'padding-normal' : ''), 
				(flush ? 'margin-flush' : ''),
				(background||'')
			].join(' ')}
		>	{title && <Fluid layout={{xs:'12', md:'9'}} className="curatedList__section_title_wrap" alignItems="center" justifyContent="center">
				<Typography component="div" className="curatedList__section_title" variant="h2">{title}</Typography>
			</Fluid>}
			{cards && cards?.length > 0 && 
			<Fluid layout={{ ms: 6, md: (listType === 'textCard') ? 6 : gridSize }} gap={{ sm: undefined, ms: "40px" }}>
				{cards.map((card, index) => {
					return (
						listType === 'simpleCard' ? <SimpleCard key={`curatedList-card-${index}`} {...card} type={listType} className="curatedList__card" /> : <BlogCard key={`curatedList-card-${index}`} {...card} type={listType} className="curatedList__card" />
					)
				})}
			</Fluid>
		}
		</Box>
	)
}

export default React.memo(CuratedList);